'use client';

import { IEmployeeDetails } from '@common/interfaces';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { selectEmployeeDetails } from '@store/selectors';
import { setEmployeeDetails } from '@store/slices/employeeSlice';
import { useEffect } from 'react';

export interface IEmployeeDetailsProviderProps {
  employeeDetails: IEmployeeDetails;
  children: React.ReactNode;
}

export const EmployeeDetailsProvider = ({ employeeDetails, children }: IEmployeeDetailsProviderProps) => {
  const dispatch = useAppDispatch();
  const employeeDetailsFromStore = useAppSelector(selectEmployeeDetails);
  useEffect(() => {
    if (employeeDetails) {
      dispatch(setEmployeeDetails({ ...employeeDetailsFromStore, ...employeeDetails }));
    }
  }, [employeeDetails]);

  return <>{children}</>;
};
